import request from "@/utils/request";

/**
 * 定义一个函数，用于构建查询字符串
 * @param {*} params 参数对象
 * @returns 查询字符串
 */
const buildQueryString = (params) => {
  // 如果参数不存在或者参数不是对象，则返回空字符串
  if (!params || typeof params !== "object") return "";

  // 获取参数对象的键，并过滤掉值为undefined、null和空字符串的键
  const query = Object.keys(params)
    .filter(
      (key) =>
        params[key] !== undefined && params[key] !== null && params[key] !== ""
    )
    // 将键值对转换为查询字符串的形式，并使用encodeURIComponent函数对值进行编码
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    // 将所有键值对连接起来，使用&符号分隔
    .join("&");

  // 如果查询字符串存在，则返回带?的查询字符串，否则返回空字符串
  return query ? `?${query}` : "";
};

/**
 * 定义一个apiRequest函数，用于发送HTTP请求
 * @param {*} method 请求方法，例如GET、POST、UPLOAD
 * @param {*} url 请求地址
 * @param {*} data 请求参数
 * @param {*} config 请求配置
 * @returns Promise对象
 */
const apiRequest = (method, url, data = {}, config = {}) => {
  // 如果请求方法是GET，则将data转换为查询字符串
  const queryParams = method === "GET" ? buildQueryString(data) : "";
  // 将url和查询字符串拼接成完整的请求地址
  const fullUrl = `${url}${queryParams}`;

  // 根据请求方法调用不同的http请求函数
  switch (method) {
    case "GET":
      return request.get(fullUrl, config);
    case "POST":
      return request.post(url, data, config);
    case "UPLOAD":
      // 对于文件上传，需要设置特殊的Content-Type
      const uploadConfig = {
        ...config,
        headers: {
          "Content-Type": "multipart/form-data",
          ...config.headers,
        },
      };
      return request.post(url, data, uploadConfig);
    default:
      // 如果请求方法不支持，则抛出错误
      throw new Error(`不支持的请求方法: ${method}`);
  }
};

// 根据电话号查询当前userId
export const getHiUser = (data) =>
  apiRequest("GET", "/system/hiUser/getUserByPhone/" + data.phone);
// 查询充值套餐列表
export const findRecharge = (data) =>
  apiRequest("GET", "/pc/recharge/findRecharge", data);
// 调取支付接口------汇付斗拱
export const payAlipayUrl = (data) =>
  apiRequest("GET", "/pc/pay/payAlipayUrl", data);
// 调取支付接口---商付通
export const paySFTUrl = (data) =>
  apiRequest("GET", "/api/pay/paySFTUrl", data);
// 调取支付接口---Smartpay
export const paySmartpayUrl = (data) =>
  apiRequest("GET", "/api/pay/smartPayUrl", data);
// 用户充值
export const userRecharge = (data) =>
  apiRequest("POST", "/pc/pay/userRecharge", data);
// 查询用户协议表 1隐私协议 2用户协议 3收款账户收集说明 4灵活用工平台综合服务协议 5.第三方SDK说明 6.充值协议 7.添加到主屏幕协议
export const findHiAgreement = (data) =>
  apiRequest("GET", "/api/agreement/findHiAgreement", data);
// 注册 / 登录
export const loginOrRegister = (data) =>
  apiRequest("POST", "/api/hiUser/loginOrRegister", data, {
    headers: { timestamp: Date.now() },
  });

// 发送验证码
export const sendVerifyCode = (phone) =>
  apiRequest(
    "GET",
    "/api/send/sendCode",
    { phone },
    { headers: { timestamp: Date.now() } }
  );

// 字典配置 返回多个
export const getDict = (data) => {
  const timestamp = Date.now();
  let url = `/api/dict/getDict?_t=${timestamp}`;
  if (data?.key) {
    url += `&key=${data.key}`;
  }
  return apiRequest("GET", url);
};

// 获取 Android 下载地址
export const getAndroidUrl = () => {
  const token = localStorage.getItem("token");
  console.log("🚀 ~ getAndroidUrl ~ token:", token);
  return apiRequest(
    "GET",
    "/api/hiUser/downloadUrl",
    {},
    {
      headers: {
        timestamp: Date.now(),
        token,
      },
    }
  );
};
